import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Radio } from "antd";
import { useMemo } from "react";
import { EServiceTemplateGroup, EUserRole, ServiceTemplateField, TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField, isServiceAllFieldsByCdnState } from "@devowl-wp/api-real-cookie-banner";
import { useServiceCdnState } from "../../../../../../hooks/service/useServiceCdnState.js";
import { useTranslation } from "../../../../../../others/i18n.js";
import { getDisableStrategies } from "../../../../../../util/template/merge-strategies.js";
import { getFieldNameTranslated } from "../../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper, FormFieldVisibilityWrapperByCdn } from "../../formFieldVisibilityWrapper.js";
import { TemplateMetaDataExtendsStrategyFormField } from "../../templateMetaDataExtendsStrategyFormField.js";
function FormFieldServiceTemplateServiceGroup() {
    const { t } = useTranslation();
    const options = useMemo(()=>[
            {
                label: t("Not set"),
                value: null,
                style: {
                    marginRight: "1rem"
                }
            },
            {
                label: t("Essential"),
                value: EServiceTemplateGroup.Essential
            },
            {
                label: t("Functional"),
                value: EServiceTemplateGroup.Functional
            },
            {
                label: t("Statistics"),
                value: EServiceTemplateGroup.Statistics
            },
            {
                label: t("Marketing"),
                value: EServiceTemplateGroup.Marketing
            }
        ], [
        t
    ]);
    const cdnFieldState = useServiceCdnState(ServiceTemplateField.Group);
    const isFormFullyVisible = useMemo(()=>isServiceAllFieldsByCdnState(cdnFieldState), [
        cdnFieldState
    ]);
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapperByCdn, {
        children: /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
            fieldNames: ServiceTemplateField.Group,
            permissionCheck: {
                whenRole: EUserRole.Translator,
                roleWhiteList: TRANSLATABLE_SERVICE_TEMPLATE_ATTRIBUTES_LIST
            },
            children: /*#__PURE__*/ _jsx(Form.Item, {
                label: getFieldNameTranslated(ServiceTemplateField.Group, t),
                required: true,
                shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || prev.isCdn !== next.isCdn || prev.dataProcessingInCountriesSpecialTreatments !== next.dataProcessingInCountriesSpecialTreatments,
                children: ({ getFieldValue })=>{
                    const extended = getFieldValue(TemplateMetaDataField.Extends);
                    return /*#__PURE__*/ _jsx(TemplateMetaDataExtendsStrategyFormField, {
                        extendsFieldName: ServiceTemplateField.Group,
                        disableStrategies: getDisableStrategies(),
                        onKeepContent: extended && /*#__PURE__*/ _jsx(Form.Item, {
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Radio.Group, {
                                defaultValue: extended[ServiceTemplateField.Group],
                                options: options,
                                optionType: "button",
                                buttonStyle: "solid",
                                disabled: true
                            })
                        }),
                        children: /*#__PURE__*/ _jsx(Form.Item, {
                            name: ServiceTemplateField.Group,
                            rules: [
                                {
                                    validator: (_, value)=>{
                                        if (value === undefined && isFormFullyVisible) {
                                            return Promise.reject(new Error(t(`Please select the appropriate group membership or "not set".`)));
                                        } else {
                                            return Promise.resolve();
                                        }
                                    }
                                }
                            ],
                            noStyle: true,
                            children: /*#__PURE__*/ _jsx(Radio.Group, {
                                options: options,
                                optionType: "button",
                                buttonStyle: "solid"
                            })
                        })
                    });
                }
            })
        })
    });
}
export { FormFieldServiceTemplateServiceGroup };
